import FormInputError from "../../../General/FormInputError";
import { v4 as uuidv4 } from "uuid";
import { states } from "../../../../js/placeholderData/states";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Controller } from "react-hook-form";
import RELEASING_AutoCompleteComboBox from "components/General/AutoCompleteComboBox/RELEASING_AutoCompleteComboBox";

export default function BeneficiaryInfoCard({
  componentIndex,
  lastComponent,
  FACStepFourRegister,
  append,
  remove,
  errors,
  control,
  clearErrors,
  setError,
  watch,
  setValue,
}) {
  const uuid = uuidv4();
  const { t } = useTranslation();
  const initialSelectedState = watch(`beneficiaries[${componentIndex}].state`);
  const initialRelationship = watch(
    `beneficiaries[${componentIndex}].relationship`
  );
  const [selectedState, setSelectedState] = useState(
    initialSelectedState || { value: "all" }
  );
  const [beneficiaryRelationship, setBeneficiaryRelationship] = useState(
    initialRelationship || { value: "all" }
  );

  return (
    <div className="mt-6 grid gap-4 grid-cols-1 lg:gap-6">
      <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[2fr,2fr,1fr]">
        {componentIndex > 0 && (
          <div className="md:col-span-3">
            <button
              className="ui-btn-primary-error my-2"
              type="button"
              onClick={() => remove(componentIndex)}
            >
              {t("FACStepBeneficiary-btn")}
            </button>
          </div>
        )}
        <div>
          <label htmlFor={`${uuid}-fn-beneficiary`} className="block mb-1">
            {t("FACStepBeneficiary-fn")}
          </label>
          <input
            id={`${uuid}-fn-beneficiary`}
            type="text"
            placeholder="Beneficiary's First Name"
            {...FACStepFourRegister(
              `beneficiaries[${componentIndex}].firstName`,
              {
                required: `Please enter a first name for beneficiary - ${
                  componentIndex + 1
                }`,
              }
            )}
          />
          <FormInputError
            id={`${uuid}-fn-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.firstName?.message
                : ""
            }
          />
        </div>

        <div>
          <label htmlFor={`${uuid}-ln-beneficiary`} className="block mb-1">
            {t("FACStepBeneficiary-ln")}
          </label>
          <input
            id={`${uuid}-ln-beneficiary`}
            type="text"
            placeholder="Beneficiary's Last Name"
            {...FACStepFourRegister(
              `beneficiaries[${componentIndex}].lastName`,
              {
                required: `Please enter a last name for beneficiary - ${
                  componentIndex + 1
                }`,
              }
            )}
          />
          <FormInputError
            id={`${uuid}-ln-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.lastName?.message
                : ""
            }
          />
        </div>

        <div>
          <label htmlFor={`${uuid}-mn-beneficiary`} className="block mb-1">
            {t("FACStepBeneficiary-middle")}
          </label>
          <input
            id={`${uuid}-mn-beneficiary`}
            type="text"
            {...FACStepFourRegister(
              `beneficiaries[${componentIndex}].middleName`
            )}
          />
          <FormInputError
            id={`${uuid}-mn-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.middleName?.message
                : ""
            }
          />
        </div>
      </div>

      <div>
        <label htmlFor={`${uuid}-sa-beneficiary`} className="block mb-1">
          {t("FACStepBeneficiary-mailling-ads-1")}
        </label>
        <input
          id={`${uuid}-sa-beneficiary`}
          type="text"
          placeholder="Beneficiary's Address"
          {...FACStepFourRegister(
            `beneficiaries[${componentIndex}].streetAddress`
          )}
        />
        <FormInputError
          id={`${uuid}-sa-beneficiary-error`}
          errorMessage={
            errors?.beneficiaries?.length
              ? errors?.beneficiaries[componentIndex]?.streetAddress?.message
              : ""
          }
        />
      </div>

      <div>
        <label htmlFor={`${uuid}-sa2-beneficiary`} className="block mb-1">
          {t("FACStepBeneficiary-mailling-ads-2")}
        </label>
        <input
          id={`${uuid}-sa2-beneficiary`}
          type="text"
          placeholder="Beneficiary's Address Line 2"
          {...FACStepFourRegister(
            `beneficiaries[${componentIndex}].streetAddress2`
          )}
        />
        <FormInputError
          id={`${uuid}-sa2-beneficiary-error`}
          errorMessage={
            errors?.beneficiaries?.length
              ? errors?.beneficiaries[componentIndex]?.streetAddress2?.message
              : ""
          }
        />
      </div>
      <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[1.5fr,1fr,1fr]">
        <div>
          <label htmlFor={`${uuid}-city-beneficiary`} className="block mb-1">
            {t("FACStepBeneficiary-city")}
          </label>
          <input
            id={`${uuid}-city-beneficiary`}
            type="text"
            placeholder="City"
            {...FACStepFourRegister(`beneficiaries[${componentIndex}].city`)}
          />
          <FormInputError
            id={`${uuid}-city-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.city?.message
                : ""
            }
          />
        </div>

        <div>
          <Controller
            name={`beneficiaries[${componentIndex}].state`}
            control={control}
            render={() => (
              <RELEASING_AutoCompleteComboBox
                labelName={t("FACStepBeneficiary-state")}
                inputPlaceholderText={t("FACStepBeneficiary-state-placeholder")}
                options={[
                  {
                    value: "all",
                    displayAs: t("FACStepBeneficiary-state"),
                    selectedPolicyDisplayAs: t("FACStepBeneficiary-state"),
                    isDisplayOnly: true,
                  },
                  ...states.map((state) => ({
                    value: state.abbreviation,
                    displayAs: state.name,
                    selectedPolicyDisplayAs: state.name,
                    isDisplayOnly: true,
                  })),
                ]}
                selectedOption={selectedState}
                setSelectedOption={(option) => {
                  setSelectedState(option);
                  if (option?.value !== "all") {
                    setValue(
                      `beneficiaries[${componentIndex}].state`,
                      option.value
                    );
                  } else {
                    setValue(`beneficiaries[${componentIndex}].state`, "");
                  }
                }}
              />
            )}
          />

          <FormInputError
            id={`${uuid}-state-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.state?.message
                : ""
            }
          />
        </div>

        <div>
          <label htmlFor={`${uuid}-zip-beneficiary`} className="block mb-1">
            {t("FACStepBeneficiary-zipcode")}
          </label>
          <input
            id={`${uuid}-zip-beneficiary`}
            type="text"
            placeholder="ZIP Code"
            {...FACStepFourRegister(`beneficiaries[${componentIndex}].zip`, {
              pattern: {
                value: /^\d{5}$/,
                message: "Please enter a valid zipcode (5 digits)",
              },
              maxLength: {
                value: 5,
                message: "Please enter only 5 digits for zipcode",
              },
            })}
          />
          <FormInputError
            id={`${uuid}-zip-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.zip?.message
                : ""
            }
          />
        </div>
      </div>

      <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[1fr,1fr,1fr]">
        <div>
          <label htmlFor={`${uuid}-phone-beneficiary`} className="block mb-1">
            {t("FACStepBeneficiary-phone")}
          </label>
          <input
            id={`${uuid}-phone-beneficiary`}
            aria-describedby={`${uuid}-phone-beneficiary-note`}
            type="text"
            placeholder="Beneficiary’s Phone Number"
            {...FACStepFourRegister(`beneficiaries[${componentIndex}].phone`)}
          />
          <FormInputError
            id={`${uuid}-phone-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.phone?.message
                : ""
            }
          />
        </div>

        <div>
          <label htmlFor={`${uuid}-email-beneficiary`} className="block mb-1">
            {t("FACStepBeneficiary-email")}
          </label>
          <input
            id={`${uuid}-email-beneficiary`}
            type="text"
            placeholder="Beneficiary’s Email Address"
            {...FACStepFourRegister(`beneficiaries[${componentIndex}].email`, {
              pattern: {
                value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                message: "Please enter a valid email",
              },
            })}
          />
          <FormInputError
            id={`${uuid}-email-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.email?.message
                : ""
            }
          />
        </div>

        <div>
          <label htmlFor={`${uuid}-dob-beneficiary`} className="block mb-1">
            {t("FACStepBeneficiary-dob")}
          </label>
          <input
            id={`${uuid}-dob-beneficiary`}
            type="date"
            {...FACStepFourRegister(`beneficiaries[${componentIndex}].dob`)}
          />
          <FormInputError
            id={`${uuid}-email-dob-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.dob?.message
                : ""
            }
          />
        </div>
      </div>
      {/* LAST ROW ON BENEFICIARY STEP */}
      <div className="grid gap-4 grid-cols-1 md:gap-y-0 md:gap-x-4 md:grid-cols-[1fr,2fr]">
        <div>
          <label htmlFor={`${uuid}-ssn-beneficiary`} className="block mb-1">
            {t("FACStepBeneficiary-ssn")}
          </label>
          <input
            id={`${uuid}-ssn-beneficiary`}
            type="text"
            aria-describedby={`${uuid}-ssn-beneficiary-note`}
            placeholder="Beneficiary's SSN"
            {...FACStepFourRegister(`beneficiaries[${componentIndex}].ssn`)}
          />
          <FormInputError
            id={`${uuid}-ssn-beneficiary-error`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.ssn?.message
                : ""
            }
          />
        </div>

        <div>
          <Controller
            name={`beneficiaries[${componentIndex}].relationship`}
            control={control}
            render={() => (
              <RELEASING_AutoCompleteComboBox
                labelName={t("FACStepBeneficiary-relationship")}
                inputPlaceholderText={t(
                  "FACStepBeneficiary-relationship-optn-1"
                )}
                options={[
                  {
                    value: "all",
                    displayAs: t("FACStepBeneficiary-relationship-optn-1"),
                    selectedPolicyDisplayAs: t(
                      "FACStepBeneficiary-relationship-optn-1"
                    ),
                    isDisplayOnly: true,
                  },
                  {
                    value: "owner",
                    displayAs: t("FACStepBeneficiary-relationship-optn-2"),
                    selectedPolicyDisplayAs: t(
                      "FACStepBeneficiary-relationship-optn-2"
                    ),
                    isDisplayOnly: true,
                  },
                  {
                    value: "spouse",
                    displayAs: t("FACStepBeneficiary-relationship-optn-3"),
                    selectedPolicyDisplayAs: t(
                      "FACStepBeneficiary-relationship-optn-3"
                    ),
                    isDisplayOnly: true,
                  },
                  {
                    value: "child",
                    displayAs: t("FACStepBeneficiary-relationship-optn-4"),
                    selectedPolicyDisplayAs: t(
                      "FACStepBeneficiary-relationship-optn-4"
                    ),
                    isDisplayOnly: true,
                  },
                  {
                    value: "dependent",
                    displayAs: t("FACStepBeneficiary-relationship-optn-5"),
                    selectedPolicyDisplayAs: t(
                      "FACStepBeneficiary-relationship-optn-5"
                    ),
                    isDisplayOnly: true,
                  },
                  {
                    value: "other",
                    displayAs: t("FACStepBeneficiary-relationship-optn-6"),
                    selectedPolicyDisplayAs: t(
                      "FACStepBeneficiary-relationship-optn-6"
                    ),
                    isDisplayOnly: true,
                  },
                ]}
                selectedOption={beneficiaryRelationship}
                setSelectedOption={(option) => {
                  setBeneficiaryRelationship(option);
                  if (option?.value !== "all") {
                    clearErrors(
                      `beneficiaries[${componentIndex}].relationship`
                    );
                    setValue(
                      `beneficiaries[${componentIndex}].relationship`,
                      option.value
                    );
                  } else {
                    setError(`beneficiaries[${componentIndex}].relationship`, {
                      message: `Please select beneficiary's relationship to the deceased - ${
                        componentIndex + 1
                      }`,
                    });
                    setValue(
                      `beneficiaries[${componentIndex}].relationship`,
                      ""
                    );
                  }
                }}
              />
            )}
            rules={{
              required: `Please select beneficiary's relationship to the deceased - ${
                componentIndex + 1
              }`,
            }}
          />

          <FormInputError
            id={`${uuid}-relationship-beneficiary`}
            errorMessage={
              errors?.beneficiaries?.length
                ? errors?.beneficiaries[componentIndex]?.relationship?.message
                : ""
            }
          />
        </div>
      </div>

      {lastComponent && (
        <div className="flex justify-start">
          <button
            className="ui-btn-secondary mt-4"
            type="button"
            onClick={() => append({ firstName: "" })}
          >
            {t("FACStepBeneficiary-add-btn")}
          </button>
        </div>
      )}
    </div>
  );
}
